import { render, staticRenderFns } from "./PayServiceInfo.vue?vue&type=template&id=0dde76dc&scoped=true"
import script from "./PayServiceInfo.vue?vue&type=script&lang=ts"
export * from "./PayServiceInfo.vue?vue&type=script&lang=ts"
import style0 from "./PayServiceInfo.vue?vue&type=style&index=0&id=0dde76dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../nhaphangtocdo/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dde76dc",
  null
  
)

export default component.exports